import axios, { AxiosPromise, AxiosRequestConfig, Method } from "axios";
import { getServerBaseApiUrl } from "./apiBaseUrl";

axios.defaults.withCredentials = true;

interface IRequestParam extends AxiosRequestConfig {
	link: string;
	body?: object;
	loginRequest?: boolean;
}

const request = <ResponseType>(
	method: Method,
	param: IRequestParam,
): AxiosPromise<ResponseType> => {
	const { link, body = {}, headers, loginRequest, ...args } = param;

	const requestBody: AxiosRequestConfig = {
		method,
		url: `${getServerBaseApiUrl()}${link}`,
		data: body,
		headers: {
			...headers,
			Authorization: !loginRequest
				? `Bearer ${window.localStorage.getItem("accessToken")}`
				: "",
		},
		...args,
	};
	return axios.request<ResponseType>(requestBody);
};

const API_CALL_TYPE: Method[] = [
	"get",
	"GET",
	"delete",
	"DELETE",
	"head",
	"HEAD",
	"options",
	"OPTIONS",
	"post",
	"POST",
	"put",
	"PUT",
	"patch",
	"PATCH",
	"purge",
	"PURGE",
	"link",
	"LINK",
	"unlink",
	"UNLINK",
];

type MethodsType = Record<Method, <T>(p: IRequestParam) => AxiosPromise<T>>;

const API = {} as MethodsType;

API_CALL_TYPE.forEach((method) => {
	API[method] = <ResponseBody>(param: IRequestParam) => {
		return request<ResponseBody>(method, param);
	};
});

export default API;
